import { ArrowRight } from 'lucide-react';
import { useTranslation } from '../hooks';

const Hero = ({ scrollToSection }) => {
  const { t } = useTranslation();

  const statsData = [
    { number: '10+', label: t.stats.projects },
    { number: '2+', label: t.stats.experience },
    { number: '10+', label: t.stats.clients },
    { number: 'Madagascar', label: t.stats.locations }
  ];

  return (
    <section id="home" className="min-h-screen bg-black text-white relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-transparent z-10"></div>
        <img
          src="https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1920&h=1080&fit=crop"
          alt="M.A CONCEPT Architecture"
          className="w-full h-full object-cover opacity-40"
        />
      </div>

      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20">
        <div className="grid lg:grid-cols-2 gap-16 items-center min-h-screen">
          <div className="space-y-8">
            {/* Logo Hero */}
            <div className="flex items-center space-x-4 mb-8">
              <div className="w-16 h-16 overflow-hidden rounded bg-white p-2">
                <img
                  src="/images/logo.jpg"
                  alt="M.A CONCEPT"
                  className="w-full h-full object-cover rounded"
                />
              </div>
              <div>
                <h1 className="text-4xl lg:text-6xl font-light tracking-wider">M.A CONCEPT</h1>
                <p className="text-lg text-gray-400 tracking-wide">{t.hero.tagline}</p>
              </div>
            </div>

            <div className="space-y-6">
              <h2 className="text-3xl lg:text-5xl font-light leading-tight">
                {t.hero.title}
                <br />
                <span className="text-2xl lg:text-4xl text-gray-300">
                  {t.hero.subtitle}
                </span>
              </h2>
              <p className="text-xl text-gray-300 max-w-xl leading-relaxed">
                {t.hero.description}
              </p>
              <div className="flex flex-col sm:flex-row gap-4 pt-6">
                <button
                  onClick={() => scrollToSection('portfolio')}
                  className="bg-white text-black px-8 py-4 text-lg font-medium transition-all hover:bg-gray-200 flex items-center justify-center space-x-2"
                >
                  <span>{t.hero.cta.projects}</span>
                  <ArrowRight size={20} />
                </button>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="border border-white text-white px-8 py-4 text-lg font-medium transition-all hover:bg-white hover:text-black flex items-center justify-center space-x-2"
                >
                  <span>{t.hero.cta.contact}</span>
                </button>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="bg-white/5 backdrop-blur-md p-8 border border-white/20">
              <h3 className="text-2xl font-light mb-6 tracking-wide">{t.hero.vision.title}</h3>
              <p className="text-gray-300 mb-8 leading-relaxed">
                {t.hero.vision.description}
              </p>

              <div className="grid grid-cols-2 gap-6">
                {statsData.map((stat, index) => (
                  <div key={index} className="text-center">
                    <div className="text-3xl font-light text-white mb-2">{stat.number}</div>
                    <div className="text-sm text-gray-400 uppercase tracking-wide">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
